export const calculateBMI = (height: string, weight: string) => {
  if (height && weight) {
    const numHeight = +height / 100;
    const numWeight = +weight;

    return (numWeight / (numHeight * numHeight)).toFixed(1);
  } else return "0";
};
